import React from "react"
import { SvgArrowRight } from "../../../components/icons"
import { useNavigate } from "react-router-dom"

interface Props {
  pathname: string
  jotformRef?: React.RefObject<HTMLDivElement>
  isBootcamp?: boolean
  isCountdownActive?: boolean
}

const Questions: React.FC<Props> = ({
  pathname,
  jotformRef,
  isBootcamp,
  isCountdownActive,
}) => {
  const navigate = useNavigate()

  const handleBootcampRegistration = () => {
    navigate("/5daybusinessbootcamp/registration")
  }

  const scrollToJotform = () => {
    if (jotformRef?.current) {
      jotformRef.current.scrollIntoView({ behavior: "smooth" })
    }
  }

  const items = isBootcamp
    ? [
        "Unsure where to start or what steps to take to grow your business?",
        "Struggling to find and enroll clients consistently?",
        "Feeling overwhelmed by the “noise” of the coaching industry?",
        "Ready for accountability, clarity, and practical tools that actually work?",
        "Looking for a business model that supports your lifestyle and financial health?",
      ]
    : [
        "Unclear where to start or what to do to run a business?",
        "Held back by feelings of overwhelm and/or imposter syndrome?",
        "Seeking accountability and support to achieve your career goals?",
        "Struggling to find clients and grow your network?",
        "Looking for a simple, streamlined, cost-effective solution to start or manage your practice?",
      ]

  return (
    <div className="py-[56px] md:py-[96px] flex flex-col items-center justify-center overflow-hidden md:px-[144px] px-4 sm:px-8 max-w-screen-xl mx-auto">
      <h2
        className="text-black text-5xl text-left font-bold leading-[48px] mb-12 mx-auto"
        style={{
          fontFamily: "BeausiteClassic",
          fontSize: "40px",
          textAlign: "center",
        }}
      >
        Are you a coach who is...
      </h2>

      <div className="w-full max-w-4xl flex flex-col gap-6">
        {items.map((text, index) => (
          <div key={index} className="flex flex-col gap-4">
            <div className="flex items-start gap-6">
              <div
                className="text-black"
                style={{
                  fontFamily: "BeausiteClassic",
                  fontSize: "24px",
                  fontWeight: 600,
                  lineHeight: "28.8px",
                  textAlign: "left",
                }}
              >
                •
              </div>
              <div
                className="text-black"
                style={{
                  fontFamily: "BeausiteClassic",
                  fontSize: "24px",
                  fontWeight: 500,
                  lineHeight: "28.8px",
                  textAlign: "left",
                }}
              >
                {text}
              </div>
            </div>
            <div className="w-full h-px bg-[#abb8c3]" />
          </div>
        ))}
      </div>
      <div className="mt-12 text-center w-full max-w-4xl">
        <div
          className="text-black mb-6"
          style={{
            fontFamily: "BeausiteClassic",
            fontSize: "22px",
            fontWeight: 500,
            lineHeight: "26.4px",
            textAlign: "center",
          }}
        >
          {isBootcamp ? (
            <>
              <span className="font-bold ">
                From Purpose to Profit: The 5-Day Business Bootcamp for Coaches
              </span>{" "}
              will help you cut through the overwhelm, focus on what matters
              most, and walk away with a clear plan to build your dream
              business.
            </>
          ) : (
            <>
              <span className="font-bold ">
                The Business Blueprint for Health Coaches will help you break
                through these blocks and more so you can build your dream
                business!
              </span>
            </>
          )}
        </div>
        <div className="flex justify-center">
          {/* Register Button */}
          {isBootcamp &&
            (isCountdownActive ? (
              <button
                className="px-6 py-3 bg-[#4750f5] text-white text-base font-bold rounded-lg flex items-center gap-2"
                onClick={handleBootcampRegistration}
              >
                <span>{"\u{1F449}"}</span> SAVE MY SEAT
              </button>
            ) : (
              <button
                className="px-6 py-3 bg-[#4750f5] text-white text-base font-bold rounded-lg flex items-center gap-2"
                onClick={scrollToJotform}
              >
                <span>{"\u{1F449}"}</span> JOIN WAITLIST
                <SvgArrowRight className="w-5 h-5" />
              </button>
            ))}
        </div>
      </div>
    </div>
  )
}

export default Questions
